import React from 'react';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { SignedDocumentsViewComponent } from './research-environment/signed-documents-view.component';

export const DataRequestSignedDocumentsComponent = () => {
    const { dataRequest } = useDataRequestContext();

    return <SignedDocumentsViewComponent dataRequest={dataRequest} />;
};
